module.exports = __webpack_public_path__ + "media/images/zalo-alert-arrow-34f0aecfcdcb48479d889d081e445dbb.svg";